import Vue from 'vue'
import Vuex from 'vuex'
import fa from "element-ui/src/locale/lang/fa";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    info: null,// 用户基本信息
    isRouterAlive: true,
    loginStatus: false,
    isLoginDialog: false, //打开和关闭登录对话框
    isRegisterDialog: false, //打开和关闭注册对话框
    isForgetPasswordVisible: false, //打开和关闭注册对话框
    designer: null,//设计师信息
    scrollOnline:true,//侧边栏悬浮框显隐

  },
  mutations: {
    setInfo(state, data) {
      state.info = data;
    },
    setIsRouterAlive(state, data) {
      state.isRouterAlive = data;
    },
    setIsLoginDialog(state, data) {
      state.isLoginDialog = data;
    },
    setIsRegisterDialog(state, data) {
      state.isRegisterDialog = data;
    },
    setIsForgetPasswordVisible(state, data) {
      state.isForgetPasswordVisible = data;
    },
    setDesigner(state, data) {
      state.designer = data;
    },
    setScrollOnline(state, data) {
      state.scrollOnline = data;
    },
  },
  actions: {
    setInfo(context, data) {
      context.commit("setInfo", data)
    },
    setIsRouterAlive(context, data) {
      context.commit("setIsRouterAlive", data)
    },
    setIsLoginDialog(context, data) {
      context.commit("setIsLoginDialog", data)
    },
    setIsRegisterDialog(context, data) {
      context.commit("setIsRegisterDialog", data)
    },
    setIsForgetPasswordVisible(context, data) {
      context.commit("setIsForgetPasswordVisible", data)
    },
    setDesigner(context, data) {
      context.commit("setDesigner", data)
    },
  }
})
